import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ArticleIcon from '@mui/icons-material/Article';
import BusinessIcon from '@mui/icons-material/Business';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PersonIcon from '@mui/icons-material/Person';
import RecyclingIcon from '@mui/icons-material/Recycling';
import SellIcon from '@mui/icons-material/Sell';
import StoreIcon from '@mui/icons-material/Store';
import { Box, Collapse, Divider, Drawer, Icon, List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/redux/store';
import logoImg from '../../../assets/logo_modoblanco.png';

const ItemLista = ({ icon, text, path, subItems, onClick }: { icon: any, text: string, path?: string, subItems?: any, onClick: (path: string) => void }) => {
    const { pathname } = useLocation();

    const [open, setOpen] = useState(false)

    return (
        <>
            <ListItemButton onClick={() => {

                path && onClick(path)

                if (subItems) {
                    setOpen(!open)
                }
            }}
                selected={pathname === path}
                sx={{
                    borderRadius: '20px',
                    marginBottom: '10px',
                }} >
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={text} />
                {subItems && (open ? <ExpandLess /> : <ExpandMore />)}

            </ListItemButton>

            {subItems && <Collapse in={open} timeout="auto" unmountOnExit>
                {subItems.map((subItem: any, i: number) => (
                    <List component="div" disablePadding key={i}>
                        <ListItemButton sx={{ pl: 3, borderRadius: '20px', height: '2rem', mb: '5px' }}
                            onClick={() => onClick(subItem.path)}
                        >
                            <ListItemIcon>
                                {subItem.icon}
                            </ListItemIcon>
                            <ListItemText primary={subItem.title} />
                        </ListItemButton>
                    </List>

                ))}


            </Collapse>}
        </>
    )

}

export const sidebarWidth = 250;


const DSidebar = ({ onClose, open }: { onClose: any, open: boolean }) => {


    const user = useAppSelector(state => state.userState.user)
    const theme = useTheme();
    const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const navigate = useNavigate()

    const adminRoutes = [
        {
            path: '/dashboard/carpetas',
            icon: <ArticleIcon />,
            title: 'Carpetas'
        },
        {
            path: '/dashboard/filtrarInformes',
            icon: <ContentPasteSearchIcon />,
            title: 'Filtrar Informes'
        },
        {
            path: '/dashboard/usuarios',
            icon: <PersonIcon />,
            title: 'Usuarios'
        },
        {
            icon: <BusinessIcon />,
            title: 'Empresas',
            subItems: [
                {
                    path: '/dashboard/empresas/ver',
                    title: 'Ver todas',
                    icon: <StoreIcon />
                },
                {
                    path: '/dashboard/empresas/crear',
                    title: 'Crear',
                    icon: <AddBusinessIcon />
                }
            ]

        },
        {
            path: '/dashboard/precios',
            icon: <SellIcon />,
            title: 'Precios'
        },
        {
            path: '/dashboard/papelera',
            icon: <RecyclingIcon />,
            title: 'Papelera'
        },
        {
            path: '/dashboard/configuracionGeneral',
            icon: <Icon>settings</Icon>,
            title: 'Configuracion'
        }

    ]

    const devRoutes = [
        {
            path: '/dashboard/chat',
            icon: <Icon>chat</Icon>,
            title: 'Chat'
        },
        {
            path: '/dashboard/dev',
            icon: <Icon>code</Icon>,
            title: 'Dev Features'
        },
        {
            path: '/dashboard/errors',
            icon: <Icon>running_with_errors</Icon>,
            title: 'Log Errors'
        }

    ]



    const content = (

        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                displayPrint: 'none',
                scrollbarWidth: 'none !important'
            }}
        >
            <div>
                <Link to="/">
                    <Box sx={{ px: 2 }}>
                        <Box
                            sx={{
                                alignItems: 'center',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'center',
                                px: 3,
                                pt: '21px',
                                borderRadius: 1
                            }}
                        >
                            <img src={logoImg} alt='PyMGestiones' style={{ height: '2rem' }} />
                        </Box>
                    </Box>
                </Link>
            </div>
            <Divider sx={{ mt: '11px', mb: '22px' }} />
            <Box sx={{ flexGrow: 1 }} aria-label="Container Router Lists">

                <List aria-label="Admin Routes"
                    sx={{ width: '100%', bgcolor: 'background.paper', p: 3 }}
                    component="nav"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            General
                        </ListSubheader>
                    }
                >


                    {
                        adminRoutes.map(({ icon, title, path, subItems }, i) => (
                            <ItemLista key={`admin-${i}`} icon={icon} text={title} path={path} subItems={subItems} onClick={(path) => {
                                onClose()
                                navigate(path)
                            }} />
                        ))
                    }
                </List>

                {user?.role === 'dev' &&
                    <List aria-label="Dev Routes"
                        sx={{ width: '100%', bgcolor: 'background.paper', p: 3 }}
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Develop features
                            </ListSubheader>
                        }
                        onClick={onClose}
                    >
                        {devRoutes.map(({ icon, title, path }, i) => (
                            <ItemLista key={`dev-${i}`} icon={icon} text={title} path={path} onClick={(path) => navigate(path)} />
                        ))}

                    </List>
                }

            </Box>
            <Divider />
            <Box
                sx={{
                    px: 2,
                    py: 3
                }}
            >




            </Box>
        </Box>


    )




    if (lgUp) {
        return (
            <Drawer
                anchor="left"
                open
                PaperProps={{
                    sx: {
                        backgroundColor: 'neutral.900',
                        color: '#GGGGG',
                        width: sidebarWidth
                    }
                }}
                variant="permanent"
            >
                {content}
            </Drawer>
        );
    }
    return (<Drawer
        open={open}
        onClose={onClose}
        anchor="left"
        variant="temporary"

        PaperProps={{
            sx: {
                backgroundColor: 'neutral.900',
                color: '#GGGGG',
                width: sidebarWidth,
                'scrollbar-width': 'none !important'

            }
        }}
        sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
    >

        {content}

    </Drawer>);
}

DSidebar.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool
};



export default DSidebar;